import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from '@/context/AuthContext';
import MainLayout from '@/components/Layout/MainLayout';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import Clientes from '@/pages/Clientes';
import ClienteDetalhe from '@/pages/ClienteDetalhe';
import Contratos from '@/pages/Contratos';
import CRMLeads from '@/pages/CRMLeads';
import CRMPerformance from '@/pages/CRMPerformance';
import Projetos from '@/pages/Projetos';
import Hospedagem from '@/pages/Hospedagem';
import Assinaturas from '@/pages/Assinaturas';
import Equipe from '@/pages/Equipe';
import MasterPanel from '@/pages/MasterPanel';
import Perfil from '@/pages/Perfil';
import FinanceiroUnificado from '@/pages/FinanceiroUnificado';
import Despesas from '@/pages/Despesas';
import Relatorios from '@/pages/Relatorios';
import FluxoCaixa from '@/pages/FluxoCaixa';
import Funcionarios from '@/pages/Funcionarios';
import Metricas from '@/pages/Metricas';
import CustosFixos from '@/pages/CustosFixos';
import ROIInvestimentos from '@/pages/ROIInvestimentos';
import '@/App.css';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "580748510212-spndljojvbfuee1o54qo716k552s8f82.apps.googleusercontent.com";

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            <Route path="/dashboard" element={<MainLayout><Dashboard /></MainLayout>} />
            <Route path="/clientes" element={<MainLayout><Clientes /></MainLayout>} />
            <Route path="/clientes/:id" element={<MainLayout><ClienteDetalhe /></MainLayout>} />
            <Route path="/contratos" element={<MainLayout><Contratos /></MainLayout>} />
            <Route path="/crm" element={<MainLayout><CRMLeads /></MainLayout>} />
            <Route path="/crm/performance" element={<MainLayout><CRMPerformance /></MainLayout>} />
            <Route path="/projetos" element={<MainLayout><Projetos /></MainLayout>} />
            <Route path="/hospedagem" element={<MainLayout><Hospedagem /></MainLayout>} />
            <Route path="/financeiro" element={<MainLayout><FinanceiroUnificado /></MainLayout>} />
            <Route path="/despesas" element={<MainLayout><Despesas /></MainLayout>} />
            <Route path="/fluxo-caixa" element={<MainLayout><FluxoCaixa /></MainLayout>} />
            <Route path="/assinaturas" element={<MainLayout><Assinaturas /></MainLayout>} />
            <Route path="/equipe" element={<MainLayout><Equipe /></MainLayout>} />
            <Route path="/funcionarios" element={<MainLayout><Funcionarios /></MainLayout>} />
            <Route path="/metricas" element={<MainLayout><Metricas /></MainLayout>} />
            <Route path="/roi" element={<MainLayout><ROIInvestimentos /></MainLayout>} />
            <Route path="/custos-fixos" element={<MainLayout><CustosFixos /></MainLayout>} />
            <Route path="/relatorios" element={<MainLayout><Relatorios /></MainLayout>} />
            <Route path="/perfil" element={<MainLayout><Perfil /></MainLayout>} />
            <Route path="/master" element={<MainLayout><MasterPanel /></MainLayout>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
